import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "@/components/loader";
import { apiURL } from "@/config";

export default function PublicResume() {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [html, setHtml] = useState("");

  useEffect(() => {
    loadResume();
  }, [token]);

  const loadResume = async () => {
    try {
      setLoading(true);
      // Fetch the resume HTML directly
      const response = await fetch(`${apiURL}/user/resume/${token}`);
      
      if (!response.ok) {
        setError("Resume not found");
        setLoading(false);
        return;
      }

      const htmlContent = await response.text();
      setHtml(htmlContent);
    } catch (err) {
      console.error("Error loading resume:", err);
      setError("Error loading resume");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
          <p className="text-lg text-gray-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-screen">
      <iframe
        srcDoc={html}
        className="w-full h-full border-0"
        title="Resume"
        sandbox="allow-same-origin"
      />
    </div>
  );
}
